var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilderdelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#444444"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_62_17678",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_62_17678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 25C10.45 25 9.97917 24.8042 9.5875 24.4125C9.19583 24.0208 9 23.55 9 23V10H8V8H13V7H19V8H24V10H23V23C23 23.55 22.8042 24.0208 22.4125 24.4125C22.0208 24.8042 21.55 25 21 25H11ZM21 10H11V23H21V10ZM13 21H15V12H13V21ZM17 21H19V12H17V21Z",
    fill: "#F82B60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilderdelete);
export default __webpack_public_path__ + "static/media/builderdelete.05e10ec3115f6eb11326d57d8d0d28cf.svg";
export { ForwardRef as ReactComponent };